<template>
  <div style="margin-top: 7rem; min-height: 80vh">
    <div class="m-5">
      <div class="container">
        <div class="w-full">
          <img :src="IMAGEURL + event.fe_thumbnail" class="w-full object-fit-cover" alt="" style="width: 100%"/>
        </div>
        <div class="">
          <div class="pl-3">
            <div class="mt-2">
              <div
                class="card-title font-weight-bold"
                style="font-size: x-large"
              >
                {{ event.fe_name }}
              </div>
              <div class="mt-1" style="font-size: medium" v-html="event.fe_description"></div>
              <div class="mt-2">
                <span class="mr-2">
                  <img src="@/assets/imgs/svgs/map-pin.svg" alt="" style="height:30px; width:30px;"/>
                </span>
                <span class="venue">
                  {{ event.fe_venue }}
                </span>
              </div>
              <div class="d-flex align-items-center mt-4">
                      <img src="@/assets/imgs/svgs/calendar_fea.svg" alt="" style="height:30px; width:30px" />
                      <span class="time ">
                        {{ new Intl.DateTimeFormat('en-US', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(event.fe_start_date)) }}
                      </span>
                    </div>
            </div>
            </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeServices from '@/apiServices/homeServices';
import { IMAGEURL } from '@/config/index';

export default {
  component:{

  },
  data(){
    return {
      event:{},
      IMAGEURL
    }
  },
  methods: {
    async getEventById(id) {
      try {
        const res = await homeServices.getEventById({id:id});
        if (res.data.status) {
          this.event = res.data.data[0];
          console.log("Event by id",this.event);
        }
      } catch (error) {
        console.error("Error in getEventById ", error);
      }
  }
 },

beforeMount() {
  const e_id = this.$route.query.e_id;
  if (e_id) {
    this.getEventById(e_id);
  }
}
}

</script>
<style scoped>
.venue,.time{
  font-size: clamp(1.2rem, 2vw, 1.2rem) !important;

}
</style>


// WEBPACK FOOTER //
// src/components/pages/FranchiseEvents/EventDetail.vue